exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.full-page[data-v-531eaa1c] {\r\n    min-height: 100vh;\r\n    width: 100%;\n}\n.login-page[data-v-531eaa1c],\r\n.register-page[data-v-531eaa1c],\r\n.callback-page[data-v-531eaa1c] {\r\n    background-color: #1c3e61;\n}\r\n", ""]);

// exports
